import {useDispatch} from 'react-redux';


import * as cartActions from '../cartActions';
import * as dateUtils from '../../../../utils/dateUtils';

import cartService from '../../../../services/CartService';


/**
 * @return {function(cartId: string): Promise<{[p: string]: *}>}
 */
function useCartCheckout() {

    const dispatch = useDispatch();

    return async cartId => {

        const cartCheckoutResponse = await cartService.loadCartCheckout(cartId);
        dispatch(cartActions.onCartLoaded(cartCheckoutResponse.cart));

        return {
            ...cartCheckoutResponse,
            cartExpireDate: dateUtils.parse(cartCheckoutResponse.cartExpireDate)
        };
    };
}


export default useCartCheckout;
